'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyOrIndexToIndex = require('./keyOrIndexToIndex');

var _keyOrIndexToIndex2 = _interopRequireDefault(_keyOrIndexToIndex);

var _updateChildKeys = require('./updateChildKeys');

var _updateChildKeys2 = _interopRequireDefault(_updateChildKeys);

var _insert = require('unmutable/lib/insert');

var _insert2 = _interopRequireDefault(_insert);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, newParcelData) {
    return function (parcelData) {

        var index = (0, _keyOrIndexToIndex2.default)(key)(parcelData) + 1;

        return (0, _pipeWith2.default)(parcelData, (0, _update2.default)('value', (0, _insert2.default)(index, newParcelData.value)), (0, _update2.default)('child', (0, _insert2.default)(index, {})), (0, _updateChildKeys2.default)());
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/insertAfter.js
// module id = 748
// module chunks = 35783957827783